import * as R from "ramda";

export const selectPaid = R.propEq("paid", "status");
export const selectAmount = (invoice) => R.sum(R.map(R.prop("amount"), invoice.line_items));
export const selectUnpaid = (invoice) =>
  R.complement(selectPaid)(invoice) && selectAmount(invoice) > 0;

export const selectApplicationID = R.prop("requirement_application_id");
